import React from 'react';
import { Modal, Button } from 'react-bootstrap';

export default function GalleryModal({ isOpen, images = [], index = 0, onClose, onPrev, onNext }) {
  const safeIndex = Math.max(0, Math.min(images.length - 1, index));
  const src = images[safeIndex]?.url || images[safeIndex];
  const isVideo = typeof src === 'string' && /\.(mp4|mov|webm|ogg|m4v)(\?|$)/i.test(src);

  return (
    <Modal show={isOpen} onHide={onClose} centered size="lg" fullscreen="sm-down" aria-labelledby="manager-gallery-title">
      <Modal.Header closeButton>
        <Modal.Title id="manager-gallery-title">Photos</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="manager-gallery-media">
          {src && (isVideo
            ? <video src={src} controls playsInline aria-label={`Video ${safeIndex + 1}`} />
            : <img src={src} alt={`Photo ${safeIndex + 1} of ${images.length}`} />)}
        </div>
        <div className="manager-gallery-controls">
          <Button variant="light" aria-label="Previous photo" onClick={onPrev} disabled={safeIndex === 0}>‹</Button>
          <span aria-live="polite">{images.length ? safeIndex + 1 : 0} / {images.length}</span>
          <Button variant="light" aria-label="Next photo" onClick={onNext} disabled={safeIndex >= images.length - 1}>›</Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
